
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  listItemDetailBasin: {
    id: "ListItemDetail.basin",
    defaultMessage: "Basin dimensions:",
  },
  listItemDetailNumber: {
    id: "ListItemDetail.number",
    defaultMessage: "Number of Troughs:",
  },
  listItemDetailPrice: {
    id: "ListItemDetail.price",
    defaultMessage: "Total price: 1.690,00 €",
  },
  listItemDetailDraft: {
    id: "ListItemDetail.draft",
    defaultMessage: "Draft",
  },
  listItemDetailRequest: {
    id: "ListItemDetail.request",
    defaultMessage: "Request",
  },
  listItemDetailOffer: {
    id: "ListItemDetail.offer",
    defaultMessage: "Offer",
  },
  listItemDetailOrder: {
    id: "ListItemDetail.order",
    defaultMessage: "Order",
  },
  listItemDetailDate: {
    id: "ListItemDetail.date",
    defaultMessage: "Last modified on",
  },
  listItemDetailFailed: {
    id: "ListItemDetail.failed",
    defaultMessage: "Failed",
  },
  listItemDetailQueued: {
    id: "ListItemDetail.queued",
    defaultMessage: "Queued",
  },
  listItemBuildingNumber: {
    id: "ListItemBuilding.number",
    defaultMessage: "Building number",
  },
  listItemOpportunityNumber: {
    id: "ListItemOpportunity.number",
    defaultMessage: "Opportunity number",
  }
});

export default MESSAGES;